import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import Modal from './Modal';

export default function Item({ elem, notasPadre = null }) {

    const { darkMode } = useDarkMode();

    const [modalOpen, setModalOpen] = useState(false)
    const [modalSoloNotas, setModalSoloNotas] = useState(false)

    const isImportado = elem.es_tipo_carga_por_importacion === true
    const notasDisponibles = elem?.notas ?? notasPadre ?? null

    const abrirModal = () => {
        setModalOpen(true)
    }

    const cerrarModal = () => {
        setModalOpen(false)
        setModalSoloNotas(false)
    }

    return (
        <div style={{ marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <h5 style={{ margin: 0, fontSize: 14, lineHeight: 1.2 }}>
                {elem.indice_completo} {elem.item.nombre}
            </h5>
            <button
                onClick={() => {
                    if (isImportado) return
                    setModalSoloNotas(false)
                    abrirModal()
                }}
                disabled={isImportado}
                title={isImportado ? 'Deshabilitado - Precarga Administrativa' : 'Agregar instancia'}
                aria-label={isImportado ? 'Deshabilitado - Precarga Administrativa' : 'Agregar instancia'}
                style={{
                    flexShrink: 0,
                    width: 22,
                    height: 22,
                    borderRadius: '6px',
                    border: '1.5px solid rgba(151, 32, 52, 0.35)',
                    backgroundColor: 'rgba(151, 32, 52, 0.07)',
                    color: '#972034',
                    fontSize: 15,
                    fontWeight: '600',
                    lineHeight: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: isImportado ? 'not-allowed' : 'pointer',
                    opacity: isImportado ? 0.35 : 1,
                    transition: 'background-color 0.15s ease, border-color 0.15s ease',
                    padding: 0,
                }}
                onMouseOver={(e) => {
                    if (!isImportado) {
                        e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.14)'
                        e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.6)'
                    }
                }}
                onMouseOut={(e) => {
                    if (!isImportado) {
                        e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.07)'
                        e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.35)'
                    }
                }}
            >
                +
            </button>
            {isImportado && (
                <span
                    style={{
                        flexShrink: 0,
                        fontSize: 12,
                        fontWeight: 700,
                        lineHeight: 1.2,
                        color: darkMode ? '#ffd8de' : '#7d1b29',
                        whiteSpace: 'nowrap'
                    }}
                >
                    Información Precargada
                </span>
            )}
            {isImportado && (
                <button
                    type="button"
                    onClick={() => {
                        setModalSoloNotas(true)
                        abrirModal()
                    }}
                    style={{
                        flexShrink: 0,
                        border: `1px solid ${darkMode ? '#ffd8de' : '#7d1b29'}`,
                        background: 'transparent',
                        color: darkMode ? '#ffd8de' : '#7d1b29',
                        fontSize: 12,
                        fontWeight: 700,
                        lineHeight: 1.2,
                        borderRadius: 4,
                        padding: '2px 8px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap'
                    }}
                >
                    Ver notas
                </button>
            )}
            <Modal elem={elem} notas={notasDisponibles} isOpen={modalOpen} soloNotas={modalSoloNotas} closeModal={cerrarModal} />
        </div>
    )
}